import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Field, reduxForm, reset, change } from 'redux-form';
import { renderCheckBox, renderAutoCompleteSingleSelect, renderAutoCompleteMultipleSelection, renderDateField, renderTextField } from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
//import PaginatorCustom from '../../../../components/paginationCustom';
import moment from 'moment';
import {
  changeClaimsStatus,getAllEVVClaimsWithServiceLines, getClaimDetailsById,
  getMasterData, getClaimMasterData, getNameAndInsuranceAutoComplete, getPatient, getPatientEncounterDetails,
  getServiceLineDetails, getServiceLocations  } from './actions/ManageClaimActions';
import { resetFiltersAndSorting, showFormatedDate, showFormattedTime, showNormalizedRate, BEHAVIOR_BLOSSOMS, EBS, NE_ABA, BESTABA, DEMO, CBG, BUILDABLOCKTHERAPY, SWANCONSULTINGINC, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, VIP, IAT } from '../../../../actions/utilAction';
import Alert from 'react-s-alert';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../components/SortingCustom';
import { Scrollbars } from 'react-custom-scrollbars';
import ClaimInternalNotesModal from './ClaimInternalNotes_Modal';
import CliamHistoryModal from './CliamHistoryModal';
import Tooltip from '../../../../components/Tooltip';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class EVVApprovedClaims extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openServiceCodeModal: false,
      openClaimModal: false,
      openSubmitClaimModal: false,
      openInternalNotesModal: false,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      ClaimServiceLineData: {},
      ClaimServiceLineId: null,
      ClaimId: null,
      PatientId: null,
      PatientIds: null,
      ServiceCodes: null,
      RenderingProviderIds: null,
      PayerName: null,
      clicked: false,
      clickedSchedule: false,
      clickedClockIn: false,
      clickedInvoice: false,
      claimIdShowHide: null,
      organizationID: 0,
      additionalClaimInfo: props.name,
      editClaimId: 0,      
      selectedClaimIds: [],
      openClaimHistoryModal: false,
      masterTags: [],
      isExcludeTag: false,
      IsSearchForSingleClaim: false,
      locationId: 0,
      ServiceLocationTypeIds: null,
    };

    this.filter = {
      sort_Column: 'claimid',
      sort_Order: 'desc',
    };

    this.handleSearchReadyToBillClaim = this.handleSearchReadyToBillClaim.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.GetPatientEncounterDetails = this.GetPatientEncounterDetails.bind(this);
    this.CloseSOAPDetail = this.CloseSOAPDetail.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
    this.handleSubmitChangeClaimStatusToSubmitted = this.handleSubmitChangeClaimStatusToSubmitted.bind(this);    
  }

  loadData(pageNumber) {
    // let fromDate = this.state.FromDate,
    //   toDate = this.state.ToDate;
    // console.log('load Data---', this.state.PayerName);
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'claimid',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        claimId: this.state.ClaimId && this.state.IsSearchForSingleClaim ? (Number.isInteger(this.state.ClaimId) ? 'CL' + this.state.ClaimId.toString().trim() : this.state.ClaimId.trim()) : null,
        PatientIds: this.state.PatientIds ? this.state.PatientIds : '',
        fromDate: this.state.FromDate ? showFormatedDate(this.state.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
        toDate: this.state.ToDate ? showFormatedDate(this.state.ToDate) : new Date(),
        payerName: this.state.PayerName ? this.state.PayerName : '',
        claimStatusId: 5,
        serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
        tagIds: this.state.masterTags,
        isExcludeTag: this.state.isExcludeTag,
        renderingProviderIds: this.state.RenderingProviderIds ? this.state.RenderingProviderIds : '',
        locationId: this.state.locationId ? this.state.locationId : 0,
        serviceLocationTypeIds: this.state.ServiceLocationTypeIds ? this.state.ServiceLocationTypeIds : '',
      },
      pageNumber: pageNumber ? pageNumber : 1,
      // pageSize: GlobalVariables.PageSize,
    };
    // console.log('searchObj........',searchObj)
    this.props.getAllEVVClaimsWithServiceLines(searchObj);
  }

  componentWillMount() {
    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);
    this.loadData();

    let masterData = { 'masterdata': 'masterInsuranceCompany,MASTERSERVICECODE,MASTERTAGSFORALL,MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERLOCATION,MASTERPATIENTLOCATION' };
    this.props.getClaimMasterData(masterData);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.readyToBillClaimData && nextProps.readyToBillClaimData !== this.props.readyToBillClaimData) {
      this.loadData();
    }
    if (nextProps.downloadStatus && nextProps.downloadStatus !== this.props.downloadStatus) {
      this.loadData();
    }
    if (nextProps.changeClaimsStatusData && nextProps.changeClaimsStatusData !== this.props.changeClaimsStatusData) {
      this.loadData();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, claimId.........', obj)
    this.setState({ openInternalNotesModal: true, ClaimId: obj.claimId  });    
  };

  handleNewRequestMultiSelect(input, selectedValues) {
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    }
    else if(input.name === 'MasterServiceCode')
    {
      this.setState({
        ServiceCodes: selectedValues,
      });
    }
    else if(input.name === 'RenderingProviderIds')
    {
      this.setState({
        RenderingProviderIds: selectedValues,
      });
    }
    else if(input.name === 'ServiceLocationTypeIds')
    {      
      this.setState({
        ServiceLocationTypeIds: selectedValues,
      });
    }
  }


  handleChangePatientInsurance = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ PayerName: selected.label })
  }


  handleSearchReadyToBillClaim(event) {
    this.setState({
      ClaimId: event.ClaimID ? event.ClaimID : null,
      IsSearchForSingleClaim: event.ClaimID ? true : false,
      PatientIds: this.state.PatientIds ? this.state.PatientIds : '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
      PayerName: this.state.PayerName ? this.state.PayerName : '',
      serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
      RenderingProviderIds: this.state.RenderingProviderIds ? this.state.RenderingProviderIds : '',
    }, () => {
      this.loadData();
    });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  handleExpandRow = (claimId) => {
    this.setState({ ClaimId: claimId });
    let display = this.refs['expandedClass' + claimId].style.display;

    if (display === 'none') {
      this.refs['expandedClass' + claimId].style.display = 'table-row';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claimId].style.display = 'none';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-ellipsis-h';
    }
  }


  loadServiceCodeModalData(patientId, obj) {
    let masterData = { 'masterdata': 'masterstaff,masterservicecode,MASTERRENDERINGPROVIDER,MASTERPATIENTLOCATION' };
    this.props.getMasterData(masterData);
    this.props.getServiceLocations(this.props.currentLocationId || null, patientId);
    this.props.getServiceLineDetails(obj.claimId || null, obj.id || null);
  }

  handleOpen = (event, obj) => {
    // console.log('event, claimId.........',event, obj)
    this.setState({ openServiceCodeModal: true, ClaimServiceLineData: null, ClaimServiceLineId: null, ClaimId: obj.claimId });
    this.loadServiceCodeModalData(obj.patientId, obj);

  };

  handleOpenHistory = (event, claimId) => {
    this.setState({
      openClaimHistoryModal: true,
      ClaimId: claimId
    });
  }

  
  handleCloseClaimHistoryModal = () => {
    this.setState({
      openClaimHistoryModal: false
    });
  }

  checkClaim = (e, checked, claimId) => {
    let isChecked = checked,
      claimData = this.props.readyToBillClaims.data;
    let selectedClaimIds = [];

    if (claimId) {
      selectedClaimIds = this.state.selectedClaimIds || [];
      if (isChecked) {
        selectedClaimIds.push(claimId);
      } else {
        let cIndex = selectedClaimIds.findIndex(obj => obj === claimId);
        selectedClaimIds.splice(cIndex, 1);
      }
    } else {
      claimData.forEach((obj, claimIndex) => {
        let claimIdCheck = `Claims[${claimIndex}].Chk`;
        if (isChecked) {
          selectedClaimIds.push(obj.claimId);
          this.props.dispatch(change('EVVApprovedClaimsForm', claimIdCheck, true));
        } else {
          this.props.dispatch(change('EVVApprovedClaimsForm', claimIdCheck, false));
        }
      });
    }   
    this.setState({ selectedClaimIds });
  }

  handleSubmitChangeClaimStatusToSubmitted() {
    let claimIds = this.state.selectedClaimIds.join(',');
    let claimStatusId = 2;
    this.props.changeClaimsStatus(claimIds, claimStatusId);
    this.checkClaim(null, false, null);
    Alert.closeAll();
  }

  handleSubmitChangeClaimStatus = (event) => {
    Alert.warning('Are you sure you want to move selected claims to submitted claims section?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleSubmitChangeClaimStatusToSubmitted,
        // id: obj.id,
      },
    });
  }
  handleClose = () => {
    this.setState({ openServiceCodeModal: false, openClaimModal: false, openSubmitClaimModal: false, openInternalNotesModal: false });
  };

  handleOnSubmit = (event, obj) => {
    // console.log('obj.............',obj);
    this.setState({ openSubmitClaimModal: true, ClaimId: obj.claimId, PatientId: obj.patientId, organizationID: this.props.loginUserInfo.organizationID });
    // this.setState({ openSubmitClaimModal: true, ClaimId: obj.claimId, PatientId: 365 });
  }

  handleReset = () => {
    this.props.dispatch(reset('EVVApprovedClaimsForm'));
    // this.props.dispatch(change('EVVApprovedClaimsForm', 'InsuranceCompany', null));
    resetFiltersAndSorting(this.filter, 'claimid', true);
    this.setState({
      openServiceCodeModal: false,
      openInternalNotesModal: false,
      ClaimServiceLineData: {},
      // ClaimData: {},
      ClaimServiceLineId: null,
      ClaimId: null,
      PatientIds: null,
      PayerName: '',
      masterTags: [],
      isExcludeTag: false,
      RenderingProviderIds: null,   
      locationId: 0,
      ServiceLocationTypeIds: null,
    }, () => {
      this.loadData();
    });
  };

  GetPatientEncounterDetails = (patientAppointmentId,encounterId) => {
    // console.log('encounterId...',encounterId);
    if (document.getElementsByName('DivSOAPdtl')[0]) {
      document.getElementsByName('DivSOAPdtl')[0].style.display = 'block';
    }
    this.props.getPatientEncounterDetails(patientAppointmentId,encounterId);
    // document.getElementsByName('DivSOAPdtl').style.display = 'block';

  }

  componentWillUnmount() {
    Alert.closeAll();
  }
  CloseSOAPDetail = () => {
    // console.log('document.getElementsByName().....',document.getElementsByName('DivSOAPdtl'))     ;
    if (document.getElementsByName('DivSOAPdtl')[0]) {
      document.getElementsByName('DivSOAPdtl')[0].style.display = 'none';
    }
  }

  renderInnerData(data) {
    return data.claimServiceLines.map((innerData, index) => {
      return (
        <tr key={innerData.id}>
          <td width="15%">{innerData.serviceCode ? innerData.serviceCode : '-'}</td>
          <td width="9%">{innerData.modifier1 ? innerData.modifier1 : ''}
            {innerData.modifier2 ? ', ' + innerData.modifier2 : ''}
            {innerData.modifier3 ? ', ' + innerData.modifier3 : ''}
            {innerData.modifier4 ? ', ' + innerData.modifier4 : ''}</td>
          <td width="4%">{innerData.quantity || '-'}</td>
          <td width="5%">{showNormalizedRate(innerData.rate || 0)}</td>
          <td width="8%">{showNormalizedRate(innerData.totalAmount || 0)}</td>
          <td width="10%">{innerData.serviceFacilityCode}</td>          
          <td width="10%"><span><Tooltip Description={innerData.scheduleLatitude + ', ' + innerData.scheduleLongitude} /></span></td>
          <td width="9%">
            <span><Tooltip Description={(data.claimEncounters[0].isClockInAfterThirtyMinOfApptStart ? '(No Verification Method Recorded)' : (innerData.clockInLatitude + ', ' + innerData.clockInLongitude)) + ' - ' + (data.claimEncounters[0].isClockOutAfterThirtyMinOfApptEnd ? '(No Verification Method Recorded)' : (innerData.clockOutLatitude + ', ' + innerData.clockOutLongitude))} /> </span>
          </td>
          {this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === VIP ?
            <td width="15%">{innerData.staffNames}</td>
            :
            <td width="15%">{innerData.isMultiplePractitioner ? innerData.staffNames : innerData.clinician}</td>            
          }
          <td width="15%">{innerData.renderingProvider || '-'}</td>
        </tr>
      );
    });
  };

  openDialog(e, claimId) {
    e.preventDefault();
    this.setState({ clicked: this.state.clicked === false ? true : false, claimIdShowHide: claimId, clickedSchedule: false, clickedSchedule : false, clickedClockIn: false, clickedInvoice: false});
  }
  openScheduleDialog(e, claimId) {
    e.preventDefault();
    this.setState({ clickedSchedule: this.state.clickedSchedule === false ? true : false, claimIdShowHide: claimId, clicked: false, clickedClockIn: false, clickedInvoice: false });
  }
  openClockInDialog(e, claimId) {
    e.preventDefault();
    this.setState({ clickedClockIn: this.state.clickedClockIn === false ? true : false, claimIdShowHide: claimId, clicked: false, clickedSchedule : false, clickedInvoice: false });
  }
  openInvoiceDialog(e, claimId) {
    e.preventDefault();
    this.setState({ clickedInvoice: this.state.clickedInvoice === false ? true : false, claimIdShowHide: claimId, clicked: false, clickedSchedule : false, clickedClockIn: false });
  }
  renderTrackHorizontal = () => {
    return <div style={{ display: 'hidden' }}></div>;
  }

  patientFirstNameSearchHandler = (value, dataSource, { source }) => {
    // console.log('value----', value, dataSource, source);
    if (source === 'change' && (value || '').length > 2) {
      this.props.getNameAndInsuranceAutoComplete('Patients', 'FirstName', value);
    }
  }

  patientLastNameSearchHandler = (value, dataSource, { source }) => {
    if (source === 'change' && (value || '').length > 2) {
      this.props.getNameAndInsuranceAutoComplete('Patients', 'LastName', value);
    }
  }

  InsuranceNameSearchHandler = (value, dataSource, { source }) => {
    if (source === 'change' && (value || '').length > 2) {
      this.props.getNameAndInsuranceAutoComplete('InsuranceCompanies', 'Name', value);
    }
  }

  firstNameFilterHandler = (value, dataSource) => {
    // console.log('firstName----', value);
    // this.handleSearchReadyToBillClaim(value);
    this.setState({
      FirstName: value,
    });
  }

  lastNameFilterHandler = (value, dataSource) => {
    // console.log('lastName----', value);
    // this.handleSearchReadyToBillClaim(value);
    this.setState({
      LastName: value,
    });
  }

  insuranceCompanyFilterHandler = (value, dataSource) => {
    // console.log('Insurance Company----', value, dataSource);
    // this.handleSearchReadyToBillClaim(value);
    this.setState({
      PayerName: value,
    });
  }

  handleNewRequest = (input, selectedValues) => {
    if (input.name === 'tags') {      
        input.onChange(selectedValues);
        this.setState({
          masterTags: selectedValues,
        }, () => this.state.masterTags.length === 0 ? this.props.dispatch(reset('EVVApprovedClaimsForm',"ExcludeTag", false)): '');
    }
    else if (input.name === 'locationId') {              
      this.setState({  locationId : selectedValues.value }, () => {input.onChange(selectedValues.value);});
    }
  }

  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }

  render() {
    // console.log(this.props.searchAutocompleteMUI);
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });

    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
      'customtable': true,
      'colorChange': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });

    return (
      <div>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchReadyToBillClaim)}>
              <div className="row mtm-20">
                <div className="col-sm-4">
                  <Field
                    autoFocus={true}
                    name="ClaimID"
                    floatingLabelText="Claim ID"
                    onChange={this.handleSearchChange}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.patientlist}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="MasterServiceCode"
                    label="Service Code"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterServiceCode}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    handleNewRequest={this.handleChangePatientInsurance}
                    options={this.props.masterInsurances}
                    component={renderAutoCompleteSingleSelect} />
                  {/* <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    maxLength="50"
                    searchTextValue={this.state.PayerName}
                    dataSource={this.props.searchAutocompleteMUI}
                    handleUpdateInput={this.InsuranceNameSearchHandler}
                    onNewRequest={this.insuranceCompanyFilterHandler}
                    component={renderAutocompleteMUI} /> */}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="RenderingProviderIds"
                    label="Rendering Provider"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterRenderingProviderIncludingInactive}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="tags"
                    label="Tags"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterTagsForAll}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                 {this.state.masterTags.length > 0 && <Field
                    name="ExcludeTag"
                    label="Exclude Tag"
                    component={renderCheckBox}
                    onChange={(e) => this.isExcludeTagHandler(e)}
                    style={stylescss.checkbox}
                  />}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="locationId"
                    label="Location (Office Location of Session)"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterLocation}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ServiceLocationTypeIds"
                    label="Service Location Type"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterPatientLocation}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
              </div> 
              <div className="row">
                <div className="col-10 col-sm-10 col-md-10 reset-btn claims_btn">
                    <RaisedButton className={this.state.selectedClaimIds.length > 0 ? "grey_btn" : "grey_btn reset-disable"} disabled={this.state.selectedClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleSubmitChangeClaimStatus(e)} >Move To Submitted</RaisedButton>
                </div> 
                <div className="col-2 col-sm-2 col-md-2 btn_rt reset-btn">
                {/* <div className="col-sm-12 btn_rt reset-btn"> */}
                  <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>

            {this.state.openInternalNotesModal ? <ClaimInternalNotesModal ClaimId={this.state.ClaimId} closeDialog={this.handleClose} /> : null}
            {this.state.openClaimHistoryModal ? <CliamHistoryModal claimHistoryId={this.state.ClaimId}  PatientId={this.state.PatientId}  closeDialog={() => this.handleCloseClaimHistoryModal()}/> : null}

            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-20">
                  {this.props.readyToBillClaims.data ? this.props.readyToBillClaims.data.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="5%">
                            <div className="table_custom-check">
                              <Field
                                name='Chkclaim'
                                component={renderCheckBox}
                                onChange={(e, checked) => this.checkClaim(e, checked, null)}
                                style={stylescss.checkbox}
                              />
                              <span>&nbsp;</span>
                            </div>
                          </th>
                          <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' /></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' /></th>
                          <th width="13%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client' /></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='payer' displayName='Payer Name' /></th>
                          <th width="8%">Scheduled Start/End</th>
                          <th width="6%">Clock In/Out</th>
                          <th width="8%">Invoice Start/End</th>
                          <th width="10%">Total($)</th>
                          <th width="10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>

                        {this.props.readyToBillClaims.data.map((data, index) => {
                          return (
                            <tr key={data.claimId}>
                              <td colSpan="10">
                                <table className={tableClass1}>
                                  <tbody>
                                    <tr>
                                      <td width="5%">
                                        <div className="table_custom-check">
                                          <Field
                                            name={`Claims[${index}].Chk`}
                                            component={renderCheckBox}
                                            onChange={(e, checked) => this.checkClaim(e, checked, data.claimId)}
                                            style={stylescss.checkbox}
                                          />
                                          <button onClick={(e) => this.handleExpandRow(data.claimId)} type="button" className="morebtn">
                                            <i ref={'expClass' + data.claimId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                                          </button>
                                          
                                        </div>
                                      </td>
                                      <td width="10%">
                                        <div className="claim" onClick={(e) => this.openDialog(e, data.claimId)} title="Click here to view session note">
                                          {'CL' + data.claimId}
                                          {this.props.viewSoapPermission ?
                                            <i className="fa fa-info-circle infoIcon" aria-hidden="true"></i>
                                            : null
                                          }
                                          <div className={this.state.clicked && this.state.claimIdShowHide === data.claimId ? 'claimbox show' : 'claimbox hide'}>
                                            <div className="claimheader">
                                              <h3>Claim ID : <span>{'CL' + data.claimId}</span></h3>
                                              <div className="claimicons">
                                                <ul>
                                                  <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                                                </ul>
                                              </div>
                                            </div>
                                            <div className="claimcontent">
                                              <h3>{data.renderingProvider}</h3>
                                              <div className="claimsoapdate">
                                                <ul>
                                                  {data.claimEncounters.map((encounterData, index) => {
                                                    return (
                                                      <li key={encounterData.patientEncounterId} >
                                                        <i className="fa fa-clock-o bluefont" aria-hidden="true"></i>
                                                        <span>{showFormattedTime(encounterData.startDateTime)}</span> - <span>{showFormattedTime(encounterData.endDateTime)}</span>
                                                        {this.props.agencyName.toUpperCase() !== SOAR && this.props.agencyName.toUpperCase() !== HYPERIONCENTER && this.props.agencyName.toUpperCase() !== HELPINGHANDS && this.props.agencyName.toUpperCase() !== FUTURES  && this.props.agencyName.toUpperCase() !== TFABA ?
                                                        <i onClick={() => this.GetPatientEncounterDetails(encounterData.patientAppointmentId,encounterData.patientEncounterId)} className="fa fa-info-circle infoIcon" aria-hidden="true"></i>
                                                        : null}
                                                      </li>
                                                    );
                                                  })
                                                  }
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </td>
                                      <td width="15%">{showFormatedDate(data.dos)}</td>
                                      <td width="13%">{data.patientName}</td>
                                      <td width="15%">{data.payer != null && data.payer.length > 15 ? SubString(data.payer, 15) : data.payer != null ? data.payer : 'N/A'}</td>
                                      <td width="8%">
                                        <div className="claim" onClick={(e) => this.openScheduleDialog(e, data.claimId)}>                                          
                                            <i className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view Schedule Datetime"></i>                                          
                                            <div className={this.state.clickedSchedule && this.state.claimIdShowHide === data.claimId ? 'claimbox show' : 'claimbox hide'}>
                                              <div className="claimheader">
                                                <h3>Claim ID : <span>{'CL' + data.claimId}</span></h3>
                                                <div className="claimicons">
                                                  <ul>
                                                    <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <div className="claimcontent">                                             
                                                <div className="claimsoapdate">
                                                  <ul>
                                                    {data.claimEncounters.map((encounterData, index) => {
                                                      return (
                                                        <li key={encounterData.patientEncounterId} >
                                                          <i className="fa fa-clock-o bluefont" aria-hidden="true"></i>
                                                          <span>{showFormattedTime(encounterData.scheduleStartDateTime)}</span> - <span>{showFormattedTime(encounterData.scheduleEndDateTime)}</span>                                                       
                                                        </li>
                                                      );
                                                    })
                                                    }
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                      </td>
                                      <td width="6%">
                                        <div className="claim" onClick={(e) => this.openClockInDialog(e, data.claimId)}>                                          
                                            <i className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view Clock In/Out Datetime"></i>                                          
                                            <div className={this.state.clickedClockIn && this.state.claimIdShowHide === data.claimId ? 'claimbox show' : 'claimbox hide'}>
                                              <div className="claimheader">
                                                <h3>Claim ID : <span>{'CL' + data.claimId}</span></h3>
                                                <div className="claimicons">
                                                  <ul>
                                                    <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <div className="claimcontent">                                             
                                                <div className="claimsoapdate">
                                                  <ul>
                                                    {data.claimEncounters.map((encounterData, index) => {
                                                      return (
                                                        <li key={encounterData.patientEncounterId} >
                                                          <i className="fa fa-clock-o bluefont" aria-hidden="true"></i>
                                                          <span>{encounterData.isClockInAfterThirtyMinOfApptStart ? showFormattedTime(encounterData.startDateTime) : showFormattedTime(encounterData.clockInDateTime)}</span> - <span>{encounterData.isClockOutAfterThirtyMinOfApptEnd ? showFormattedTime(encounterData.endDateTime) : showFormattedTime(encounterData.clockOutDateTime)}</span>                                                       
                                                        </li>
                                                      );
                                                    })
                                                    }
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                      </td>
                                      <td width="8%">
                                        <div className="claim" onClick={(e) => this.openInvoiceDialog(e, data.claimId)}>                                          
                                            <i className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view Invoice Datetime"></i>                                          
                                            <div className={this.state.clickedInvoice && this.state.claimIdShowHide === data.claimId ? 'claimbox show' : 'claimbox hide'}>
                                              <div className="claimheader">
                                                <h3>Claim ID : <span>{'CL' + data.claimId}</span></h3>
                                                <div className="claimicons">
                                                  <ul>
                                                    <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <div className="claimcontent">                                             
                                                <div className="claimsoapdate">
                                                  <ul>
                                                    {data.claimEncounters.map((encounterData, index) => {
                                                      return (
                                                        <li key={encounterData.patientEncounterId} >
                                                          <i className="fa fa-clock-o bluefont" aria-hidden="true"></i>
                                                          <span>{showFormattedTime(encounterData.startDateTime)}</span> - <span>{showFormattedTime(encounterData.endDateTime)}</span>                                                       
                                                        </li>
                                                      );
                                                    })
                                                    }
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                      </td>
                                      <td width="10%">{showNormalizedRate(data.totalAmount || 0)}</td>
                                      <td width="10%">
                                        {/* <button onClick={(e) => this.handleOpenInternalNotes(e, data)} type="button" title="Add Internal Notes" className="tbactionbtn valuefont"><i className="fa fa-plus-square" aria-hidden="true"></i></button>  */}
                                        <button onClick={(e) => this.handleOpenHistory(e, data.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>
                                      </td>
                                    </tr>
                                    <tr className="nohover" ref={'expandedClass' + data.claimId} style={{ 'display': 'table-row' }}>
                                      <td></td>
                                      <td colSpan="10">
                                        <table className={tableClass2}>
                                          <thead>
                                            <tr>
                                              <th width="15%">Service Code</th>
                                              <th width="9%">Modifiers</th>
                                              <th width="4%">Unit</th>
                                              <th width="5%">Rate($)</th>
                                              <th width="8%">Amount($)</th>
                                              <th width="10%">EVV Loc. Code</th>
                                              <th width="10%">Scheduled Start/End GPS</th>        
                                              <th width="9%">Clock-in / Clock-out GPS</th>  
                                              <th width="15%">Practitioner</th>
                                              <th width="15%">Rend. Provider</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.renderInnerData(data)}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          );
                        })
                        }
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="5%"><span>&nbsp;</span></th>
                          <th width="10%"><span>Claim ID</span></th>
                          <th width="15%"><span>DOS</span></th>
                          <th width="15%"><span>Client</span></th>
                          <th width="15%">Payer Name</th>
                          <th width="20%">Additional Payer Info.</th>
                          <th width="10%">Total Amt</th>
                          {/* <th width="10%">Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="7">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}
                  {/* {this.props.readyToBillClaims.data && this.props.readyToBillClaims.meta && this.props.readyToBillClaims.meta['totalPages'] && this.props.readyToBillClaims.meta['totalPages'] > 1 ?
                    <PaginatorCustom data={this.props.readyToBillClaims.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                    : null} */}

                </div>
              </div>
            </div>

          </div>
        </div>
        {/* Drag Drop Div*/}
        {this.props.patientEncounterDetailsData ?
          <div className="soapdrag" name="DivSOAPdtl">
            <div className="soapdragheader">
              <h3>Visit Detail</h3>
              <i className="material-icons" onClick={this.CloseSOAPDetail}>clear</i>
            </div>

            <div className="visitcontent">
              <Scrollbars renderTrackHorizontal={this.renderTrackHorizontal}>
                <div className="visititem">
                  <div className="visititem-title"><i className="flaticon flaticon-interface-1"></i>Service Type</div>
                  <div className="itemdiagnosis">
                    {this.props.patientEncounterDetailsData.isDirectService ? 'Direct' : 'Indirect'}
                  </div>
                </div>
                {this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS ?
                <div className="visititem">
                  <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Session Note</div>
                  <div className="itemdivide">
                    <h5>Location And People</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.locationAndPeople}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Skill Acquisition Goals</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.skillAcquisitionGoals}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Maladaptive Behaviors And Intervention</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.maladaptiveBehaviorsAndIntervention}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Choices And Reinforcement</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.choicesAndReinforcement}</p>
                  </div>

                  <div className="itemdivide">
                    <h5>Health And Safety</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.healthAndSafety}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Environmental Changes</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.environmentalChanges}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Parent Participation / Caregiver Training</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.parentParticipationTraining}</p>
                  </div>
                  <div className="itemdivide">
                    <h5>Supervision Of RBT</h5>
                    <p>{this.props.patientEncounterDetailsData.sessionNotes_BehaviorBlossoms.supervisionOfRBT}</p>
                  </div>
                </div>
                : null}

                {(this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT) ?
                  <div className="visititem">
                    <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                    <div className="itemdivide">
                      <h5>Subjective</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.subjective}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Objective</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.objective}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Assessment</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.assessment}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Plan</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.plans}</p>
                    </div>
                  </div>
                  : null}

                {(this.props.agencyName.toUpperCase().startsWith(EBS)) ?
                  <div className="visititem">
                     {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS.plans}</p>
                          </div>
                        </div>:null}
                      {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                              <h5>Service Coordinator Name</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.serviceCoordinatorName}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Type Of Service:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="OT"
                                      label="OT"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.ot}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="PT"
                                      label="PT"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.pt}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ST"
                                      label="ST"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.st}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="SI"
                                      label="SI"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.si}
                                      component={renderCheckBox}
                                    />
                                  </div>                                    
                                  <div className='col-sm-12'>
                                      <Field
                                        name="OtherTypeofService"
                                        label="Other"
                                        disabled={true}
                                        checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.otherTypeofService}
                                        component={renderCheckBox}
                                      />
                                    </div>
                                    {this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.otherTypeofService ?
                                      <div className='col-sm-12'>
                                        <h5>Other Notes</h5>
                                        <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.otherTypeofServiceNotes}</p>
                                    </div>: null}                                                      
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Type Of Session:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Initial"
                                      label="Initial"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.initial}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Ongoing"
                                      label="Ongoing"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.ongoing}
                                      component={renderCheckBox}
                                    />
                                  </div>                                                                 
                                  <div className='col-sm-12'>
                                      <Field
                                        name="OtherTypeofSession"
                                        label="Other"
                                        disabled={true}
                                        checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.otherTypeofSession}
                                        component={renderCheckBox}
                                      />
                                    </div>
                                    {this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.otherTypeofSession ?
                                      <div className='col-sm-12'>
                                        <h5>Other Notes</h5>
                                        <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.otherTypeofSessionNotes}</p>
                                    </div>: null}                                                      
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Outcome(s)/Goal(s) from IFSP/IEP</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.goals}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Child And Family Outcome Update</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.childOutcomeUpdate}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Activities And Routines, Family participation and how strategies were used</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.activitiesAndRoutines}</p>
                            </div>   
                            <div className="itemdivide">
                              <h5>Strategies Used:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="DirectTeaching"
                                      label="Direct Teaching"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.directTeaching}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Demonstration"
                                      label="Demonstration"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.demonstration}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="GuidedPractice"
                                      label="Guided Practice"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.guidedPractice}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="CaregiverPractice"
                                      label="Caregiver Practice"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.caregiverPractice}
                                      component={renderCheckBox}
                                    />
                                  </div>     
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ProblemSolving"
                                      label="Problem Solving"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.problemSolving}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Reflection"
                                      label="Reflection"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.reflection}
                                      component={renderCheckBox}
                                    />
                                  </div>                               
                                  <div className='col-sm-12'>
                                      <Field
                                        name="OtherStrategiesUsed"
                                        label="Other"
                                        disabled={true}
                                        checked={this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.otherStrategiesUsed}
                                        component={renderCheckBox}
                                      />
                                    </div>
                                    {this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.otherStrategiesUsed ?
                                      <div className='col-sm-12'>
                                        <h5>Other Notes</h5>
                                        <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.otherStrategiesUsedNotes}</p>
                                    </div>: null}                                                      
                                </div>                                
                            </div> 
                            <div className="itemdivide">
                              <h5>Progree information/data collection</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.dataCollection}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Plan for next session and opportunites for practice</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.planForNextSession}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Date Of Next Session</h5>
                              <p>{showFormatedDate(this.props.patientEncounterDetailsData.sessionNotes_EBSPA_EarlyIntervention.dateOfNextSession)}</p>
                            </div>                         
                        </div>:null}
                        {this.props.patientEncounterDetailsData.notetypeId === 3 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                            <div className="itemdivide">
                              <h5>Service Coordinator Name</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.serviceCoordinatorName}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Descipline:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="OT"
                                      label="OT"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.ot}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="PT"
                                      label="PT"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.pt}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ST"
                                      label="ST"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.st}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ECE"
                                      label="ECE"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.ece}
                                      component={renderCheckBox}
                                    />
                                  </div>                                                
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Type Of Service:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Service"
                                      label="Service"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_TypeofService.service}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Evaluation"
                                      label="Evaluation"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_TypeofService.evaluation}
                                      component={renderCheckBox}
                                    />
                                  </div>                                                                                                                                                     
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Participated In Therapy:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Mom"
                                      label="Mom"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.mom}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="GrandParent"
                                      label="Grand Parent"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.grandParent}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Dad"
                                      label="Dad"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.dad}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Caregiver"
                                      label="Caregiver"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.caregiver}
                                      component={renderCheckBox}
                                    />
                                  </div>  
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Siblings"
                                      label="Siblings"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.siblings}
                                      component={renderCheckBox}
                                    />
                                  </div>                                                
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Session Status:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="InitialSession"
                                      label="Initial Session"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.initialSession}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="LastSession"
                                      label="LastS ession"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.lastSession}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="MakeUp"
                                      label="Make Up"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.makeUp}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ProviderCancelled"
                                      label="Provider Cancelled"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.providerCancelled}
                                      component={renderCheckBox}
                                    />
                                  </div>  
                                  <div className='col-sm-12'>
                                    <Field
                                      name="FamilyCancelled"
                                      label="Family Cancelled"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.familyCancelled}
                                      component={renderCheckBox}
                                    />
                                  </div>                                                
                                </div>                                
                            </div>
                            <div className="itemdivide">
                              <h5>Outcome(s)/Goal(s) from IFSP/IEP</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.goals}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Child And Family Outcome Update</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.childOutcomeUpdate}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Summary Of Session</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.summaryOfSession}</p>
                            </div>  
                            <div className="itemdivide">
                              <h5>Progress Monitering</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.progressMoniteringgoals}</p>
                            </div>                            
                            <div className="itemdivide">
                              <h5>Strategies Used:</h5>
                                <div className="row">
                                  <div className='col-sm-12'>
                                    <Field
                                      name="DirectTeaching"
                                      label="Direct Teaching"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.directTeaching}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Demonstration"
                                      label="Demonstration"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.demonstration}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="GuidedPractice"
                                      label="Guided Practice"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.guidedPractice}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="CaregiverPractice"
                                      label="Caregiver Practice"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.caregiverPractice}
                                      component={renderCheckBox}
                                    />
                                  </div>     
                                  <div className='col-sm-12'>
                                    <Field
                                      name="ProblemSolving"
                                      label="Problem Solving"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.problemSolving}
                                      component={renderCheckBox}
                                    />
                                  </div>
                                  <div className='col-sm-12'>
                                    <Field
                                      name="Reflection"
                                      label="Reflection"
                                      disabled={true}
                                      checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.reflection}
                                      component={renderCheckBox}
                                    />
                                  </div>                               
                                  <div className='col-sm-12'>
                                      <Field
                                        name="OtherStrategiesUsed"
                                        label="Other"
                                        disabled={true}
                                        checked={this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.otherStrategiesUsed}
                                        component={renderCheckBox}
                                      />
                                    </div>
                                    {this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.otherStrategiesUsed ?
                                      <div className='col-sm-12'>
                                        <h5>Other Notes</h5>
                                        <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.otherStrategiesUsedNotes}</p>
                                    </div>: null}                                                      
                                </div>                                
                            </div> 
                            <div className="itemdivide">
                              <h5>Progree information/data collection</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.dataCollection}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Plan for next session and opportunites for practice</h5>
                              <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.planForNextSession}</p>
                            </div>
                            <div className="itemdivide">
                              <h5>Date Of Next Session</h5>
                              <p>{showFormatedDate(this.props.patientEncounterDetailsData.sessionNotes_EBS_Delaware_EI.dateOfNextSession)}</p>                              
                            </div>                         
                        </div>:null}
                        {this.props.patientEncounterDetailsData.notetypeId === 4 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>IFSP Note</div>                          
                          <div className="itemdivide">
                            <h5>Meeting Attendees</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_IFSP_DevelopmentTime.meetingAttendees}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Summary Of Session</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_EBS_IFSP_DevelopmentTime.summaryOfSession}</p>
                          </div>
                        </div>:null}
                  </div>
                  : null}

                {(this.props.agencyName.toUpperCase() === CBG) ?
                  <div className="visititem">
                  {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_CBG.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_CBG.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_CBG.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_CBG.plans}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Supervision</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_CBG.supervision}</p>
                          </div>
                        </div>   
                      : null}

                {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                <div>
                  <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Progress Notes</div>
                    <div className="itemdivide">
                      <h5>Parent report/ observation upon arrival</h5>

                      <div className="row">
                        <div className='col-sm-12'>
                          <Field
                            name="Happy"
                            label="Happy"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.happy}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Tired"
                            label="Tired"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.tired}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Sick"
                            label="Sick"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sick}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Wellrested"
                            label="Well rested"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.wellrested}
                            component={renderCheckBox}
                          />
                        </div>  
                        <div className='col-sm-12'>
                          <Field
                            name="Sensorysicking"
                            label="Sensory seeking"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sensorysicking}
                            component={renderCheckBox}
                          />
                        </div>   
                        <div className='col-sm-12'>
                          <Field
                            name="Upset"
                            label="Upset"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.upset}
                            component={renderCheckBox}
                          />
                        </div>   
                        <div className='col-sm-12'>
                            <Field
                              name="OtherPN"
                              label="Other"
                              disabled={true}
                              checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN}
                              component={renderCheckBox}
                            />
                          </div>
                          {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPNNotes}</p>
                          </div>: null}  
                        <div className='col-sm-12'>
                          <Field
                            name="IsWarrantTherapy"
                            label="In a state that warrants therapy?"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy}
                            component={renderCheckBox}
                          />
                        </div>                      
                      </div>                         
                      <h5>Symptoms observed during session</h5>
                      <div className="row">
                      <div className='col-sm-12'>
                          <Field
                            name="SkillDeftReceptiveLanguage"
                            label="Deficits in receptive language"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftReceptiveLanguage}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftAdaptiveBehavior"
                            label="Deficits in adaptive behavior"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftAdaptiveBehavior}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftExpressiveLanguage"
                            label="Deficits in expressive language"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftExpressiveLanguage}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftImitationSkills"
                            label="Deficits in imitation skills"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftImitationSkills}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftSocialSkills"
                            label="Deficits in social skills"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftSocialSkills}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftCommunitySafetySkills"
                            label="Deficits in community safety skills"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftCommunitySafetySkills}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftPlaySkills"
                            label="Deficits in play skills"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftPlaySkills}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SkillDeftOther"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther}
                            component={renderCheckBox}
                          />
                        </div>
                      
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOtherNotes}</p>
                          </div>: null}  


                          <div className='col-sm-12'>
                          <Field
                            name="TechBehSampling"
                            label="Sampling/Preference Assessment/Pairing"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSampling}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="TechBehBehavioralSkillsTraining"
                            label="Behavioral skills training"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehBehavioralSkillsTraining}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="TechBehDTT"
                            label="DTT"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehDTT}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="TechBehShaping"
                            label="Chaining/Shaping"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehShaping}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="TechBehErrorlessTeaching"
                            label="Errorless Teaching"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehErrorlessTeaching}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="TechBehSystematicPromptFading"
                            label="Systematic prompt fading"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSystematicPromptFading}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="TechBehNET"
                            label="NET"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehNET}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="TechBehOther"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOtherNotes}</p>
                          </div>: null}  

                      </div>
                  
                      <h5>Progress towards treatment goals</h5>
                      <div className="row">
                        <div className='col-sm-12'>
                            <h5>Programs observed during session</h5>
                            <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments1}</p>
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SessionMastery1"
                            label="Session mastery"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery1}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ContinueTeaching1"
                            label="Continue teaching"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching1}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Generalized1"
                            label="Generalized"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized1}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Hold1"
                            label="Hold/discontinue"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold1}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="DevelopProtocol1"
                            label="Develop/edit protocol"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol1}
                            component={renderCheckBox}
                          />
                        </div>                            
                        <div className='col-sm-12'>
                          <Field
                            name="OtherTG1"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1 ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes1}</p>
                          </div>: null} 
                      </div>

                      <div className="row">
                        <div className='col-sm-12'>
                            <h5>Programs observed during session</h5>
                            <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments2}</p>
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SessionMastery2"
                            label="Session mastery"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery2}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ContinueTeaching2"
                            label="Continue teaching"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching2}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Generalized2"
                            label="Generalized"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized2}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Hold2"
                            label="Hold/discontinue"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold2}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="DevelopProtocol2"
                            label="Develop/edit protocol"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol2}
                            component={renderCheckBox}
                          />
                        </div>                            
                        <div className='col-sm-12'>
                          <Field
                            name="OtherTG2"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2 ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes2}</p>
                          </div>: null} 
                      </div>

                      <div className="row">
                        <div className='col-sm-12'>
                            <h5>Programs observed during session</h5>
                            <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments3}</p>
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="SessionMastery3"
                            label="Session mastery"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery3}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ContinueTeaching3"
                            label="Continue teaching"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching3}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Generalized3"
                            label="Generalized"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized3}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Hold3"
                            label="Hold/discontinue"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold3}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="DevelopProtocol3"
                            label="Develop/edit protocol"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol3}
                            component={renderCheckBox}
                          />
                        </div>                            
                        <div className='col-sm-12'>
                          <Field
                            name="OtherTG3"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3 ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes3}</p>
                          </div>: null} 
                      </div>


                      <h5>Generalization and Maintenance Checks</h5>
                      <div className="row">
                        <div className='col-sm-12'>
                          <Field
                            name="GenReceptiveLanguage"
                            label="Receptive Language"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genReceptiveLanguage}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="GenPlay"
                            label="Play"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genPlay}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="GenExpressiveLanguage"
                            label="Expressive Language"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genExpressiveLanguage}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="GenFCT"
                            label="FCT"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genFCT}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="GenImitation"
                            label="Imitation"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genImitation}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="GenAdaptiveBehavior"
                            label="Adaptive Behavior"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genAdaptiveBehavior}
                            component={renderCheckBox}
                          />
                        </div>

                        <div className='col-sm-12'>
                          <Field
                            name="GenOther"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOtherNotes}</p>
                          </div>: null} 
                        
                      </div>

                      <div className="row">
                        <div className='col-sm-12'>
                            <h5>Total # of trials/session</h5>
                            <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.totalNumberOfTrials}</p>
                        </div>
                      </div>

                      <h5>Progress</h5>
                      <div className="row">                            
                        <div className='col-sm-12'>
                          <Field
                            name="ProgressAllTargets"
                            label="All targets maintained at 80% or above"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressAllTargets}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ProgressMostTargets"
                            label="Most targets maintained at 80% or above"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMostTargets}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ProgressMultipleTargets"
                            label="Multiple targets did not maintain at 80% or above"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMultipleTargets}
                            component={renderCheckBox}
                          />
                        </div>                                                       
                        <div className='col-sm-12'>
                          <Field
                            name="ProgressOtherTargets"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargetsNotes}</p>
                          </div>: null} 
                      </div>


                      <h5>Summary of Maladaptive Behaviors</h5>
                      <div className="row">
                        <div className='col-sm-12'>
                          <Field
                            name="DifferentialReinforcement"
                            label="Differential reinforcement"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.differentialReinforcement}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Extinction"
                            label="Extinction"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.extinction}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="BehavioralMomentum"
                            label="Behavioral momentum"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.behavioralMomentum}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="FCT"
                            label="FCT"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.fct}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Assessment"
                            label="Assessment/Observation"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.assessment}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="OperantReinforcement"
                            label="Operant reinforcement"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.operantReinforcement}
                            component={renderCheckBox}
                          />
                        </div>


                        <div className='col-sm-12'>
                          <Field
                            name="AntecedentManipulations"
                            label="Antecedent manipulations"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.antecedentManipulations}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="TaskAnalysis"
                            label="Task Analysis"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.taskAnalysis}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="PositiveReinforcement"
                            label="Positive reinforcement"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.positiveReinforcement}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="Punishment"
                            label="Punishment"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.punishment}
                            component={renderCheckBox}
                          />
                        </div>                           

                        <div className='col-sm-12'>
                          <Field
                            name="OtherBR"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBRNotes}</p>
                          </div>: null} 
                        
                      </div>

                      <h5>Protocol Modification by BCBA/BCaBA (only) </h5>
                      <div className="row">
                        <div className='col-sm-12'>
                          <Field
                            name="DataAnalysis"
                            label="Data Analysis/graphing"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.dataAnalysis}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="UpdatedBIP"
                            label="Updated BIP"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.updatedBIP}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="AssessmentPM"
                            label="Assessment/FBA"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.assessmentPM}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ModificationsToCurrentProgramming"
                            label="Modifications to current programming"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.modificationsToCurrentProgramming}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="DevelopNewProgramming"
                            label="Develop new programming"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.developNewProgramming}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="OtherPM"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPMNotes}</p>
                          </div>: null} 
                        
                      </div>

                      <h5>BT Guidance by BCBA/BCaBA (only) </h5>
                      <div className="row">
                        <div className='col-sm-12'>
                          <Field
                            name="AccuracyOfDataCollection"
                            label="Accuracy of data collection"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.accuracyOfDataCollection}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="EffectivelyImplementsDTT"
                            label="Effectively implements DTT"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsDTT}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="EffectivelyImplementsClientBIP"
                            label="Effectively implements client BIP"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsClientBIP}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="EffectivelyImplementsErrorCorrection"
                            label="Effectively implements Error Correction"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsErrorCorrection}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="EffectivelyImplementsSystematicPromptFading"
                            label="Effectively implements systematic prompt fading"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsSystematicPromptFading}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="EffectivelyEstablishesInstructionalControl"
                            label="Effectively establishes instructional control"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyEstablishesInstructionalControl}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="ImplementsReinforcementProceduresEffectively"
                            label="Implements reinforcement procedures effectively"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.implementsReinforcementProceduresEffectively}
                            component={renderCheckBox}
                          />
                        </div>
                        <div className='col-sm-12'>
                          <Field
                            name="OtherBT"
                            label="Other"
                            disabled={true}
                            checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT}
                            component={renderCheckBox}
                          />
                        </div>
                        {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT ?
                            <div className='col-sm-12'>
                              <h5>Other Notes</h5>
                              <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBTNotes}</p>
                          </div>: null} 
                        
                      </div>                         
                      <h5>Notes</h5>
                      <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.notes}</p>
                    </div>                      
                </div>                      
                : null}
              </div>
                  : null}

                {this.props.agencyName.toUpperCase() === NE_ABA ?
                  <div className="visititem">
                    <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Therapy Session Notes</div>
                    <div className="itemdivide">
                      <h5>Notes</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_NE_ABA.notes}</p>
                    </div>                      
                  </div>
                : null}

                {this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS ?
                  <div className="visititem">
                    <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Therapy Session Notes</div>
                    <div className="itemdivide">
                      <h5>Notes</h5>
                      <p>{this.props.patientEncounterDetailsData.sessionNotes_PBS.notes}</p>
                    </div>                      
                  </div>
                : null}

                
                {this.props.agencyName.toUpperCase() === BESTABA ?                  
                  <div className="visititem">
                  {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                    <div>
                      <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Therapy Session Notes</div>
                        <div className="itemdivide">
                        <h5>Present during session</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="ParentsOrGuardian"
                                label="Parents/ Guardian"                    
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.parentsOrGuardian}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BCBAOrBCaBA"
                                label="BCBA/ BCaBA"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.bcbaOrBCaBA}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SiblingsOrPeer"
                                label="Siblings/ Peer"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.siblingsOrPeer}                                  
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Client"
                                label="Client"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.client}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT"
                                label="Other BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.otherBT}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.otherBT ?
                              <div className='col-sm-12'>
                                <h5>Other BT Notes</h5>
                                <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.otherBTNotes}</p>
                            </div>: null}
                          </div>
                          
                          <h5>Evidence-based interventions used</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="AntecedentInterventions"
                                label="Antecedent interventions"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.antecedentInterventions}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DifferentialReinforcement"
                                label="Differential reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.differentialReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DTT"
                                label="DTT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.dtt}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Extinction"
                                label="Extinction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.extinction}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Modeling"
                                label="Modeling"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.modeling}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TAOrChaining"
                                label="TA / Chaining"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.taOrChaining}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="VideoModeling"
                                label="Video modeling"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.videoModeling}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="VisualSupport"
                                label="Visual support"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.visualSupport}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Reinforcement"
                                label="Reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.reinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SelfManagement"
                                label="Self-management"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.selfManagement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SocialNarratives"
                                label="Social narratives"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.socialNarratives}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SocialSkillsTraining"
                                label="Social Skills Training"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.socialSkillsTraining}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="FCT"
                                label="FCT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.fct}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="NET"
                                label="NET"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.net}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="PromptingAndPromptFading"
                                label="Prompting and prompt fading"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.promptingAndPromptFading}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Baseline"
                                label="Baseline"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.baseline}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="RapportBuildingOrPairing"
                                label="Rapport Building/pairing"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.rapportBuildingOrPairing}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TokenEconomy"
                                label="Token Economy"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.tokenEconomy}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BehavioralMomentum"
                                label="Behavioral momentum"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.behavioralMomentum}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT2"
                                label="Other BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.other}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.other ?
                              <div className='col-sm-12'>
                                <h5>Other Notes</h5>
                                <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.otherNotes}</p>
                              </div>: null}
                          </div>
                          <h5>Program Areas worked on</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="Communication"
                                label="Communication"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.communication}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ADLs"
                                label="ADLs"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.adLs}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SocialSkills"
                                label="Social Skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.socialSkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProblemBehavior"
                                label="Problem Behavior"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.problemBehavior}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SafetySkills"
                                label="Safety Skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.safetySkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="PlayOrLeisure"
                                label="Play / Leisure"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.playOrLeisure}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SelfManagementRegulation"
                                label="Self-monitoring"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.selfManagementRegulation}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ToleranceOfNoveltyOrChange"
                                label="Tolerance of novelty / change"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.toleranceOfNoveltyOrChange}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT3"
                                label="Other BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.other}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.other ?
                              <div className='col-sm-12'>
                                <h5>Other Notes</h5>
                                <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.otherNotes}</p>
                              </div>:null}
                          </div>
                          <h5>Behavior / Instructional challenges present</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="Aggression"
                                label="Aggression"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.aggression}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="NonCompliance"
                                label="Non-compliance"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.nonCompliance}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Elopement"
                                label="Elopement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.elopement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="PropertyDestruction"
                                label="Property Destruction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.propertyDestruction}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SIB"
                                label="SIB"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.sib}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="LackOfMotivation"
                                label="Lack of motivation"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.lackOfMotivation}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Inattention"
                                label="Inattention"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.inattention}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ObsessiveOrPerseverative"
                                label="Obsessive/ perseverative"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.obsessiveOrPerseverative}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT4"
                                label="Other BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.other}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.other ? 
                              <div className='col-sm-12'>
                                <h5>Other Notes</h5>
                                <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.otherNotes}</p>
                              </div>:null}
                          </div>
                          <h5>Interventions used to address</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="FollowedBSP"
                                label="Followed BSP"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.followedBSP}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ABCData"
                                label="ABC Data"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.abcData}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ConsultedWithBCBA"
                                label="Consulted with BCBA"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.consultedwithBCBA}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT5"
                                label="Other BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.other}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.other ?
                              <div className='col-sm-12'>
                                <h5>Other Notes</h5>
                                <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.otherNotes}</p>
                              </div>:null}
                          </div>
                          <div className="row">
                            <div className='col-sm-12 mt-35'>
                              <Field
                                name="IsTreatmentGoal"
                                label="Did the client demonstrate progress towards treatment goals:"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.other}
                                component={renderCheckBox}
                              />
                            </div>
                          </div>                            
                          <h5>Notes</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_BT_BESTABA.notes}</p>
                        </div>                      
                    </div>                      
                    : null}

                    {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                    <div>
                      <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Therapy Session Notes</div>
                        <div className="itemdivide">
                          <h5>Present during session</h5>

                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="ParentsOrGuardian"
                                label="Parents/ Guardian"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.parentsOrGuardian}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BCBAOrBCaBA"
                                label="BCBA/ BCaBA"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.bcbaOrBCaBA}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SiblingsOrPeer"
                                label="Siblings/ Peer"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.siblingsOrPeer}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BT"
                                label="BT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.bt}
                                component={renderCheckBox}
                              />
                            </div>  
                            <div className='col-sm-12'>
                              <Field
                                name="Client"
                                label="Client"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.client}
                                component={renderCheckBox}
                              />
                            </div>                              
                          </div>
                          <h5>Direction of Technician</h5>
                          <div className="row">
                           <div className='col-sm-12'>
                              <Field
                                name="ObserveTechnicianImplementing"
                                label="Observe technician implementing most recent protocol modification"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.observeTechnicianImplementing}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProvideCorrectiveFeedback"
                                label="Provide corrective feedback"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.provideCorrectiveFeedback}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProvideConfirmationFeedback"
                                label="Provide confirmation feedback about treatment"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.provideConfirmationFeedback}
                                component={renderCheckBox}
                              />
                            </div>
                          </div>
                          <h5>Protocols modified during session</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="IncreaseOrChangeTarget"
                                label="Increase / change target"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.increaseOrChangeTarget}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ChangePromptLevelPromptingProcedure"
                                label="Change prompt level / prompting procedure"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.changePromptLevelPromptingProcedure}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TreatmentGoals"
                                label="Treatment goals"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.treatmentGoals}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Reinforcers"
                                label="Reinforcers"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.reinforcers}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ScheduleOfReinforcement"
                                label="Schedule of reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.scheduleOfReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DiscriminativeStimulus"
                                label="Discriminative stimulus"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.discriminativeStimulus}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Materials"
                                label="Materials"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.materials}
                                component={renderCheckBox}
                              />
                            </div>
                          </div>
                          <h5>Implementation by BCBA</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="TestModifiedProtocol"
                                label="Test modified protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.testModifiedProtocol}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BaselineOrProbeNewProtocol"
                                label="Baseline/ probe new protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.baselineOrProbeNewProtocol}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ModelModifiedProtocol"
                                label="Model modified protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.modelModifiedProtocol}
                                component={renderCheckBox}
                              />
                            </div>
                          </div>
                          <h5>Observations to determine protocols are effective</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.observationsToDetermineProtocols}</p>
                          <h5>Parent/Caregiver Training</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.parentOrCaregiverTraining}</p>
                          <h5>Assessment/ Treatment and Planning</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.assessmentOrTreatmentAndPlanning}</p>
                          <h5>Notes</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_BESTABA.notes}</p>
                        </div>                      
                    </div>                      
                    : null}
                  </div>
                  : null}

{this.props.agencyName.toUpperCase() === SWANCONSULTINGINC ?
                  <div className="visititem">
                    {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.plans}</p>
                          </div>
                      </div>   
                      : null}     
                  
                     {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Psychological Therapy Session Notes</div>
                          <div className="itemdivide">
                            <h5>Notes</h5>
                            <p>{this.props.patientEncounterDetailsData.sessionNotes_Psychological_SWAN.notes}</p>
                          </div>
                        </div>   
                    : null}                   
                  </div>
                : null}

                {this.props.agencyName.toUpperCase() === CAS ?
                  
                  <div className="visititem">
                  {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.plans}</p>
                          </div>
                      </div>   
                      : null}

                    {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                    <div>
                      <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Progress Notes</div>
                        <div className="itemdivide">
                          <h5>Parent report/ observation upon arrival</h5>

                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="Happy"
                                label="Happy"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.happy}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Tired"
                                label="Tired"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.tired}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Sick"
                                label="Sick"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sick}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Wellrested"
                                label="Well rested"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.wellrested}
                                component={renderCheckBox}
                              />
                            </div>  
                            <div className='col-sm-12'>
                              <Field
                                name="Sensorysicking"
                                label="Sensory seeking"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sensorysicking}
                                component={renderCheckBox}
                              />
                            </div>   
                            <div className='col-sm-12'>
                              <Field
                                name="Upset"
                                label="Upset"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.upset}
                                component={renderCheckBox}
                              />
                            </div>   
                            <div className='col-sm-12'>
                                <Field
                                  name="OtherPN"
                                  label="Other"
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN}
                                  component={renderCheckBox}
                                />
                              </div>
                              {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPNNotes}</p>
                              </div>: null}  
                            <div className='col-sm-12'>
                              <Field
                                name="IsWarrantTherapy"
                                label="In a state that warrants therapy?"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy}
                                component={renderCheckBox}
                              />
                            </div>                      
                          </div>                         
                          <h5>Symptoms observed during session</h5>
                          <div className="row">
                           <div className='col-sm-12'>
                              <Field
                                name="SkillDeftReceptiveLanguage"
                                label="Deficits in receptive language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftReceptiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftAdaptiveBehavior"
                                label="Deficits in adaptive behavior"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftAdaptiveBehavior}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftExpressiveLanguage"
                                label="Deficits in expressive language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftExpressiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftImitationSkills"
                                label="Deficits in imitation skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftImitationSkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftSocialSkills"
                                label="Deficits in social skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftSocialSkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftCommunitySafetySkills"
                                label="Deficits in community safety skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftCommunitySafetySkills}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftPlaySkills"
                                label="Deficits in play skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftPlaySkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther}
                                component={renderCheckBox}
                              />
                            </div>
                           
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOtherNotes}</p>
                              </div>: null}  


                              <div className='col-sm-12'>
                              <Field
                                name="TechBehSampling"
                                label="Sampling/Preference Assessment/Pairing"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSampling}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehBehavioralSkillsTraining"
                                label="Behavioral skills training"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehBehavioralSkillsTraining}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehDTT"
                                label="DTT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehDTT}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehShaping"
                                label="Chaining/Shaping"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehShaping}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehErrorlessTeaching"
                                label="Errorless Teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehErrorlessTeaching}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehSystematicPromptFading"
                                label="Systematic prompt fading"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSystematicPromptFading}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehNET"
                                label="NET"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehNET}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOtherNotes}</p>
                              </div>: null}  

                          </div>
                      
                          <h5>Progress towards treatment goals</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments1}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery1"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching1"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized1"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold1"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol1"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol1}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG1"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes1}</p>
                              </div>: null} 
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments2}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery2"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching2"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized2"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold2"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol2"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol2}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG2"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes2}</p>
                              </div>: null} 
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments3}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery3"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching3"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized3"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold3"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol3"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol3}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG3"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes3}</p>
                              </div>: null} 
                          </div>


                          <h5>Generalization and Maintenance Checks</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="GenReceptiveLanguage"
                                label="Receptive Language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genReceptiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenPlay"
                                label="Play"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genPlay}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenExpressiveLanguage"
                                label="Expressive Language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genExpressiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenFCT"
                                label="FCT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genFCT}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenImitation"
                                label="Imitation"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genImitation}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenAdaptiveBehavior"
                                label="Adaptive Behavior"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genAdaptiveBehavior}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="GenOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOtherNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Total # of trials/session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.totalNumberOfTrials}</p>
                            </div>
                          </div>

                          <h5>Progress</h5>
                          <div className="row">                            
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressAllTargets"
                                label="All targets maintained at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressAllTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressMostTargets"
                                label="Most targets maintained at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMostTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressMultipleTargets"
                                label="Multiple targets did not maintain at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMultipleTargets}
                                component={renderCheckBox}
                              />
                            </div>                                                       
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressOtherTargets"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargetsNotes}</p>
                              </div>: null} 
                          </div>


                          <h5>Summary of Maladaptive Behaviors</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="DifferentialReinforcement"
                                label="Differential reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.differentialReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Extinction"
                                label="Extinction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.extinction}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BehavioralMomentum"
                                label="Behavioral momentum"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.behavioralMomentum}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="FCT"
                                label="FCT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.fct}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Assessment"
                                label="Assessment/Observation"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.assessment}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OperantReinforcement"
                                label="Operant reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.operantReinforcement}
                                component={renderCheckBox}
                              />
                            </div>


                            <div className='col-sm-12'>
                              <Field
                                name="AntecedentManipulations"
                                label="Antecedent manipulations"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.antecedentManipulations}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TaskAnalysis"
                                label="Task Analysis"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.taskAnalysis}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="PositiveReinforcement"
                                label="Positive reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.positiveReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Punishment"
                                label="Punishment"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.punishment}
                                component={renderCheckBox}
                              />
                            </div>                           

                            <div className='col-sm-12'>
                              <Field
                                name="OtherBR"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBRNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <h5>Protocol Modification by BCBA/BCaBA (only) </h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="DataAnalysis"
                                label="Data Analysis/graphing"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.dataAnalysis}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="UpdatedBIP"
                                label="Updated BIP"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.updatedBIP}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="AssessmentPM"
                                label="Assessment/FBA"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.assessmentPM}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ModificationsToCurrentProgramming"
                                label="Modifications to current programming"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.modificationsToCurrentProgramming}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopNewProgramming"
                                label="Develop new programming"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.developNewProgramming}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherPM"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPMNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <h5>BT Guidance by BCBA/BCaBA (only) </h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="AccuracyOfDataCollection"
                                label="Accuracy of data collection"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.accuracyOfDataCollection}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsDTT"
                                label="Effectively implements DTT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsDTT}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsClientBIP"
                                label="Effectively implements client BIP"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsClientBIP}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsErrorCorrection"
                                label="Effectively implements Error Correction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsErrorCorrection}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsSystematicPromptFading"
                                label="Effectively implements systematic prompt fading"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsSystematicPromptFading}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyEstablishesInstructionalControl"
                                label="Effectively establishes instructional control"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyEstablishesInstructionalControl}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ImplementsReinforcementProceduresEffectively"
                                label="Implements reinforcement procedures effectively"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.implementsReinforcementProceduresEffectively}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBTNotes}</p>
                              </div>: null} 
                            
                          </div>                         
                          <h5>Notes</h5>
                          <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.notes}</p>
                        </div>                      
                    </div>                      
                    : null}
                  </div>
                                    

              : null}

                {this.props.agencyName.toUpperCase() === VICTORIOUSLEARNING ?
                  
                  <div className="visititem">
                  {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.plans}</p>
                          </div>
                      </div>   
                      : null}

                    {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                    <div>
                      <div className="visititem-title"><i className="flaticon flaticon-interface-2"></i>Progress Notes</div>
                        <div className="itemdivide">
                          <h5>Parent report/ observation upon arrival</h5>

                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="Happy"
                                label="Happy"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.happy}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Tired"
                                label="Tired"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.tired}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Sick"
                                label="Sick"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sick}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Wellrested"
                                label="Well rested"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.wellrested}
                                component={renderCheckBox}
                              />
                            </div>  
                            <div className='col-sm-12'>
                              <Field
                                name="Sensorysicking"
                                label="Sensory seeking"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.sensorysicking}
                                component={renderCheckBox}
                              />
                            </div>   
                            <div className='col-sm-12'>
                              <Field
                                name="Upset"
                                label="Upset"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.upset}
                                component={renderCheckBox}
                              />
                            </div>   
                            <div className='col-sm-12'>
                                <Field
                                  name="OtherPN"
                                  label="Other"
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN}
                                  component={renderCheckBox}
                                />
                              </div>
                              {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.otherPNNotes}</p>
                              </div>: null}  
                            <div className='col-sm-12'>
                              <Field
                                name="IsWarrantTherapy"
                                label="In a state that warrants therapy?"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy}
                                component={renderCheckBox}
                              />
                            </div>                      
                          </div>                         
                          <h5>Symptoms observed during session</h5>
                          <div className="row">
                           <div className='col-sm-12'>
                              <Field
                                name="SkillDeftReceptiveLanguage"
                                label="Deficits in receptive language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftReceptiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftAdaptiveBehavior"
                                label="Deficits in adaptive behavior"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftAdaptiveBehavior}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftExpressiveLanguage"
                                label="Deficits in expressive language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftExpressiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftImitationSkills"
                                label="Deficits in imitation skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftImitationSkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftSocialSkills"
                                label="Deficits in social skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftSocialSkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftCommunitySafetySkills"
                                label="Deficits in community safety skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftCommunitySafetySkills}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftPlaySkills"
                                label="Deficits in play skills"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftPlaySkills}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SkillDeftOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther}
                                component={renderCheckBox}
                              />
                            </div>
                           
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOtherNotes}</p>
                              </div>: null}  


                              <div className='col-sm-12'>
                              <Field
                                name="TechBehSampling"
                                label="Sampling/Preference Assessment/Pairing"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSampling}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehBehavioralSkillsTraining"
                                label="Behavioral skills training"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehBehavioralSkillsTraining}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehDTT"
                                label="DTT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehDTT}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehShaping"
                                label="Chaining/Shaping"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehShaping}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehErrorlessTeaching"
                                label="Errorless Teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehErrorlessTeaching}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TechBehSystematicPromptFading"
                                label="Systematic prompt fading"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSystematicPromptFading}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehNET"
                                label="NET"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehNET}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="TechBehOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOtherNotes}</p>
                              </div>: null}  

                          </div>
                      
                          <h5>Progress towards treatment goals</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments1}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery1"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching1"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized1"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold1"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold1}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol1"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol1}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG1"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes1}</p>
                              </div>: null} 
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments2}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery2"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching2"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized2"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold2"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold2}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol2"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol2}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG2"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes2}</p>
                              </div>: null} 
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Programs observed during session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_SymptomsObserved_CAS.sessionComments3}</p>
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="SessionMastery3"
                                label="Session mastery"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ContinueTeaching3"
                                label="Continue teaching"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Generalized3"
                                label="Generalized"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Hold3"
                                label="Hold/discontinue"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold3}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopProtocol3"
                                label="Develop/edit protocol"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol3}
                                component={renderCheckBox}
                              />
                            </div>                            
                            <div className='col-sm-12'>
                              <Field
                                name="OtherTG3"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3 ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes3}</p>
                              </div>: null} 
                          </div>


                          <h5>Generalization and Maintenance Checks</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="GenReceptiveLanguage"
                                label="Receptive Language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genReceptiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenPlay"
                                label="Play"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genPlay}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenExpressiveLanguage"
                                label="Expressive Language"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genExpressiveLanguage}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenFCT"
                                label="FCT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genFCT}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenImitation"
                                label="Imitation"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genImitation}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="GenAdaptiveBehavior"
                                label="Adaptive Behavior"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genAdaptiveBehavior}
                                component={renderCheckBox}
                              />
                            </div>

                            <div className='col-sm-12'>
                              <Field
                                name="GenOther"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOther ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.genOtherNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <div className="row">
                            <div className='col-sm-12'>
                                <h5>Total # of trials/session</h5>
                                <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.totalNumberOfTrials}</p>
                            </div>
                          </div>

                          <h5>Progress</h5>
                          <div className="row">                            
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressAllTargets"
                                label="All targets maintained at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressAllTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressMostTargets"
                                label="Most targets maintained at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMostTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressMultipleTargets"
                                label="Multiple targets did not maintain at 80% or above"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressMultipleTargets}
                                component={renderCheckBox}
                              />
                            </div>                                                       
                            <div className='col-sm-12'>
                              <Field
                                name="ProgressOtherTargets"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargetsNotes}</p>
                              </div>: null} 
                          </div>


                          <h5>Summary of Maladaptive Behaviors</h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="DifferentialReinforcement"
                                label="Differential reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.differentialReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Extinction"
                                label="Extinction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.extinction}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="BehavioralMomentum"
                                label="Behavioral momentum"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.behavioralMomentum}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="FCT"
                                label="FCT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.fct}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Assessment"
                                label="Assessment/Observation"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.assessment}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OperantReinforcement"
                                label="Operant reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.operantReinforcement}
                                component={renderCheckBox}
                              />
                            </div>


                            <div className='col-sm-12'>
                              <Field
                                name="AntecedentManipulations"
                                label="Antecedent manipulations"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.antecedentManipulations}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="TaskAnalysis"
                                label="Task Analysis"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.taskAnalysis}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="PositiveReinforcement"
                                label="Positive reinforcement"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.positiveReinforcement}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="Punishment"
                                label="Punishment"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.punishment}
                                component={renderCheckBox}
                              />
                            </div>                           

                            <div className='col-sm-12'>
                              <Field
                                name="OtherBR"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBRNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <h5>Protocol Modification by BCBA/BCaBA (only) </h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="DataAnalysis"
                                label="Data Analysis/graphing"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.dataAnalysis}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="UpdatedBIP"
                                label="Updated BIP"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.updatedBIP}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="AssessmentPM"
                                label="Assessment/FBA"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.assessmentPM}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ModificationsToCurrentProgramming"
                                label="Modifications to current programming"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.modificationsToCurrentProgramming}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="DevelopNewProgramming"
                                label="Develop new programming"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.developNewProgramming}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherPM"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPMNotes}</p>
                              </div>: null} 
                            
                          </div>

                          <h5>BT Guidance by BCBA/BCaBA (only) </h5>
                          <div className="row">
                            <div className='col-sm-12'>
                              <Field
                                name="AccuracyOfDataCollection"
                                label="Accuracy of data collection"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.accuracyOfDataCollection}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsDTT"
                                label="Effectively implements DTT"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsDTT}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsClientBIP"
                                label="Effectively implements client BIP"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsClientBIP}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsErrorCorrection"
                                label="Effectively implements Error Correction"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsErrorCorrection}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyImplementsSystematicPromptFading"
                                label="Effectively implements systematic prompt fading"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsSystematicPromptFading}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="EffectivelyEstablishesInstructionalControl"
                                label="Effectively establishes instructional control"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyEstablishesInstructionalControl}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="ImplementsReinforcementProceduresEffectively"
                                label="Implements reinforcement procedures effectively"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.implementsReinforcementProceduresEffectively}
                                component={renderCheckBox}
                              />
                            </div>
                            <div className='col-sm-12'>
                              <Field
                                name="OtherBT"
                                label="Other"
                                disabled={true}
                                checked={this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT}
                                component={renderCheckBox}
                              />
                            </div>
                            {this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBTNotes}</p>
                              </div>: null} 
                            
                          </div>                         
                          <h5>Notes</h5>
                          <p>{this.props.patientEncounterDetailsData.progressNotes_CAS.notes}</p>
                        </div>                      
                    </div>                      
                    : null}
                  </div>
                                    

              : null}

          {this.props.agencyName.toUpperCase() === ABAORLANDO ?
                  <div className="visititem">
                  {this.props.patientEncounterDetailsData.notetypeId === 1 ?
                        <div>
                          <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                          <div className="itemdivide">
                            <h5>Subjective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.subjective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Objective</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.objective}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Assessment</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.assessment}</p>
                          </div>
                          <div className="itemdivide">
                            <h5>Plan</h5>
                            <p>{this.props.patientEncounterDetailsData.soapNotes.plans}</p>
                          </div>
                      </div>   
                      : null}

                    {this.props.patientEncounterDetailsData.notetypeId === 2 ?
                      <div>
                        <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Notes RBT </div>
                        <div className="itemdivide">
                          <h5>Communication</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.communication}</p>
                        </div>
                        <div className="itemdivide">
                          <h5>Social</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.social}</p>
                        </div>
                        <div className="itemdivide">
                          <h5>Adaptive</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.adaptive}</p>
                        </div>
                        <div className="itemdivide">
                          <h5>Behavior Replacement Skills</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.behaviorReplacementSkills}</p>
                        </div>
                        <div className="itemdivide">
                          <h5>Behavior Incidents</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.behaviorIncidents}</p>
                        </div>
                        <div className="itemdivide">
                          <h5>Choices Offered</h5>
                          <p>{this.props.patientEncounterDetailsData.sessionNotes_RBT_ABAORLANDO.choicesOffered}</p>
                        </div>
                      </div>                     
                    : null}

                    {this.props.patientEncounterDetailsData.notetypeId === 3 ?
                      <div>
                        <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Notes BCBA </div>
                          <div className="itemdivide">
                          <h5>Who was involved in session?</h5>
                            <div className="row">
                              <div className='col-sm-12'>
                                <Field
                                  name="RBT"
                                  label="RBT"                    
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.rbt}
                                  component={renderCheckBox}
                                />
                              </div>
                              <div className='col-sm-12'>
                                <Field
                                  name="BCBA"
                                  label="BCBA"
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.bcba}
                                  component={renderCheckBox}
                                />
                              </div>
                              <div className='col-sm-12'>
                                <Field
                                 name="ParentOrCaregive"
                                 label="Parent / Caregive"
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.parentOrCaregive}                                  
                                  component={renderCheckBox}
                                />
                              </div>                              
                              <div className='col-sm-12'>
                                <Field
                                  name="Other"
                                  label="Other"
                                  disabled={true}
                                  checked={this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.other}
                                  component={renderCheckBox}
                                />
                              </div>
                              {this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.other ?
                                <div className='col-sm-12'>
                                  <h5>Other Notes</h5>
                                  <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.otherNote}</p>
                              </div>: null}
                              <div className='col-sm-12'>
                                  <h5>Description Of Activities</h5>
                                  <p>{this.props.patientEncounterDetailsData.sessionNotes_BCBA_ABAORLANDO.descriptionOfActivities}</p>
                              </div>
                            </div>
                            
                        </div>
                        
                      </div>                     
                    : null}

                  </div>
              : null}

                {this.props.agencyName.toUpperCase() !== BEHAVIOR_BLOSSOMS && !this.props.agencyName.toUpperCase().startsWith(EBS) && this.props.agencyName.toUpperCase() !== CBG && this.props.agencyName.toUpperCase() !== DEMO && this.props.agencyName.toUpperCase() !== IAT && this.props.agencyName.toUpperCase() !== BUILDABLOCKTHERAPY && this.props.agencyName.toUpperCase() !== NE_ABA && this.props.agencyName.toUpperCase() !== BESTABA 
                && this.props.agencyName.toUpperCase() !== SWANCONSULTINGINC && this.props.agencyName.toUpperCase() !== CAS && this.props.agencyName.toUpperCase() !== VICTORIOUSLEARNING && this.props.agencyName.toUpperCase() !== ABAORLANDO && this.props.agencyName.toUpperCase() !== POSITIVEBEHAVIORSTEPS ?
                  <div className="visititem">
                    <div className="visititem-title"><i className="flaticon flaticon-bathroom"></i>Session Note</div>
                    <div className="itemdivide">
                      <h5>Subjective</h5>
                      <p>{this.props.patientEncounterDetailsData.soapNotes.subjective}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Objective</h5>
                      <p>{this.props.patientEncounterDetailsData.soapNotes.objective}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Assessment</h5>
                      <p>{this.props.patientEncounterDetailsData.soapNotes.assessment}</p>
                    </div>
                    <div className="itemdivide">
                      <h5>Plan</h5>
                      <p>{this.props.patientEncounterDetailsData.soapNotes.plans}</p>
                    </div>
                  </div>
                  : null}
                <div className="visititem">
                  <div className="visititem-title"><i className="flaticon flaticon-interface-1"></i>CPT CODE</div>
                  <div className="cptcodes">
                    <ul>
                      {this.props.patientEncounterDetailsData.patientEncounterServiceCodes.map((data, index) => {
                        return (
                          <li title={data.description}>({data.serviceCode}{data.attachedModifiers ? ':' + data.attachedModifiers : ''}) {(data.description || '').length > 50 ? (data.description || '').substring(0, 50) + '...' : data.description}</li>
                        );
                      })
                      }
                    </ul>
                  </div>
                </div>
                <div className="visititem">
                  <div className="visititem-title"><i className="flaticon flaticon-gym"></i>Diagnosis</div>
                  <div className="itemdiagnosis">
                    {/* <h5>11-07-2017 <span className="greenfont">(Active)</span></h5> */}
                    {this.props.patientEncounterDetailsData.patientEncounterDiagnosisCodes.map((data, index) => {
                      return (
                        <p title={data.description}>({data.icdCode}) {(data.description || '').length > 50 ? (data.description || '').substring(0, 50) + '...' : data.description}</p>
                      );
                    })
                    }

                  </div>
                  {/* <div className="itemdiagnosis">
                                <h5>11-07-2017 <span className="yellowfont">(Inactive)</span></h5>
                                <p>(A0017) Enterotoxigenic Test</p>
                              </div> */}
                </div>
              </Scrollbars>
            </div>

          </div>
          : null}
        {/* Drag Drop Div*/}
      </div>

    );
  }
};
EVVApprovedClaims = reduxForm({
  form: 'EVVApprovedClaimsForm',
})(EVVApprovedClaims);
// const selectorSettledClaimsForm = formValueSelector('EVVApprovedClaimsForm');

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [],
    patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'BILLING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'BILLING_CLAIMS' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permissio

  let viewSoapPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_VIEWSOAP')[0].permission : false;
  let submitClaimPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_SUBMITCLAIM')[0].permission : false;
  // let updateClaimPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_UPDATECLAIM')[0].permission : false;
  let addServiceCodePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_ADD_SERVICECODE')[0].permission : false;
  let updateServiceCodePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_UPDATE_SERVICECODE')[0].permission : false;
  let deleteServiceCodePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_DELETE_SERVICECODE')[0].permission : false;
  let generateBatchEDIClaimPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_GENERATEBATCH_EDICLAIM')[0].permission : false;

  // End For Role Permission

  // console.log('state.billing.readyToBillClaimData......', state.billing.Autocomplete_MUI);
  let searchedData = [];
  if (state.billing.Autocomplete_MUI) {
    searchedData = state.billing.Autocomplete_MUI.data.map((obj) => obj.value);
  }

  let masterInsurances = [];
  let masterServiceCode = [];
  let masterTagsForAll = [];
  let masterLocation = [],  masterPatientLocation = [];
  let masterRenderingProviderIncludingInactive = [];
  if (state.billing.claimMasterData) {
    masterInsurances = state.billing.claimMasterData.insuranceCompanies || [];
    masterServiceCode = state.billing.claimMasterData.masterServiceCode || [];
    masterTagsForAll = state.billing.claimMasterData.masterTagsforAll || [];
    masterRenderingProviderIncludingInactive = state.billing.claimMasterData.masterRenderingProviderIncludingInactive || [];
    masterLocation = state.billing.claimMasterData.masterLocation || [];
    masterPatientLocation = state.billing.claimMasterData.masterPatientLocation || [];
  }

  return {
    master_data: state.billing.master_data,
    masterTagsForAll: masterTagsForAll,        
    masterInsurances: masterInsurances,
    masterServiceCode: masterServiceCode,
    masterRenderingProviderIncludingInactive: masterRenderingProviderIncludingInactive,
    currentLocationId: state.login.currentLocationId,
    readyToBillClaims: state.billing.readyToBillClaims,
    readyToBillClaimData: state.billing.readyToBillClaimData,
    downloadStatus: state.billing.downloadStatus,
    searchAutocompleteMUI: searchedData,
    patientlist: patients,
    changeClaimsStatusData: state.billing.changeClaimsStatus,
    // claimServiceLines: state.billing.claimServiceLines,
    // claimData: state.billing.claimData,
    // AdditionalClaimInfo: selectorSettledClaimsForm(state, 'AdditionalClaimInfo'),
    patientEncounterDetailsData: state.billing.PatientEncounterDetailsData.data,
    loginUserInfo: state.login.loginUserInfo,
    viewSoapPermission: viewSoapPermission, // For Roler Permissions
    submitClaimPermission: submitClaimPermission, // For Roler Permissions
    // updateClaimPermission: updateClaimPermission, // For Roler Permissions
    addServiceCodePermission: addServiceCodePermission, // For Roler Permissions
    updateServiceCodePermission: updateServiceCodePermission, // For Roler Permissions
    deleteServiceCodePermission: deleteServiceCodePermission, // For Roler Permissions
    generateBatchEDIClaimPermission: generateBatchEDIClaimPermission, // For Roler Permissions
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    masterLocation: masterLocation,
    masterPatientLocation: masterPatientLocation,
  };
}

export default connect(mapStateToProps, { getMasterData, changeClaimsStatus, getClaimMasterData, getAllEVVClaimsWithServiceLines, getClaimDetailsById, getPatientEncounterDetails, getServiceLocations, getServiceLineDetails, getNameAndInsuranceAutoComplete, getPatient })(EVVApprovedClaims);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/EVVApprovedClaims.js